<script>
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher();

  export let disabled = false

  let keysDown = new Set([])
  // let latency = 0.0
  let strokeStarted = false
  
  const onKeydown = function(event){
    // const handlerStartTime = performance.now()

    if(disabled){ return }

    // is it the first key pressed in this stroke?
    if(keysDown.size == 0 && strokeStarted == false){
      dispatch('go')
      // console.log('strokeStarted')
    } else {
      dispatch('update', { keysDown: keysDown.size+1 })
    }

    // we're off the tight loop, tidy up
    if(keysDown.size == 0 && strokeStarted == false){
      strokeStarted = true
      if(keysDown.has('Space')){
        dispatch('spacebar')
      }
    }

    keysDown.add(event.code)
    keysDown = keysDown // for svelte, bless its heart

    // latency = performance.now() - handlerStartTime
  }

  const onKeyup = function(event){
    if(disabled){ return }

    // is it the last key released in this stroke?
    if(keysDown.size == 1){
      strokeStarted = false
      // console.log('strokeEnded')
    }
    keysDown.delete(event.code)
    keysDown = keysDown // for svelte
  }
  
</script>

<svelte:window on:keydown={onKeydown} on:keyup={onKeyup} />